import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-bubble-item-list',
    templateUrl: './bubble-item-list.component.html',
    styleUrls: ['./bubble-item-list.component.scss'],
    standalone: false
})
export class BubbleItemListComponent {
    @Input() extractLabelFn: (any) => string = (v) => v;
    @Input() options: any[];
    @Output() onRemoveElement = new EventEmitter<any>();

    onElementClicked(element: any) {
        this.emitRemove(element);
    }

    emitRemove(element: any) {
        this.onRemoveElement.emit(element);
    }
}
